export const env = process.env.ENV as 'mainnet' | 'testnet' | 'test' | 'local';
export const isProduct = env === 'mainnet';
export const isTestnet = env === 'testnet';
export const isTest = env === 'test';
export const isLocal = env === 'local';
export const isDev = isTest || isLocal;
export const isBrowser = typeof window !== 'undefined';
export const appName = process.env.APP_NAME;
export const appPath = process.env.BASE_PATH || '';
export const pipelineEnv = process.env.PIPELINE_ENV;

/** 默认location */
const getSSGDefaultLocation = () => {
  if (isDev) {
    return {
      hostname: `www.${pipelineEnv}.bybit.com`,
      origin: `https://www.${pipelineEnv}.bybit.com`,
      protocol: 'https:',
    };
  }

  if (isTestnet) {
    return {
      hostname: 'testnet.bybit.com',
      origin: `https://testnet.bybit.com`,
      protocol: 'https:',
    };
  }

  return {
    hostname: 'www.bybit.com',
    origin: `https://www.bybit.com`,
    protocol: 'https:',
  };
};

export const DEFAULT_LOCATION = getSSGDefaultLocation();

/** domain */
export const domain = (() => {
  const { hostname } = isBrowser ? window.location : DEFAULT_LOCATION;
  if (hostname.endsWith('org')) {
    return hostname.split('.').slice(-2).join('.');
  }
  if (!hostname.endsWith('com')) {
    return hostname.split('.').slice(-3).join('.');
  }
  return hostname.split('.').slice(-2).join('.');
})();

export const origin = (() => {
  const { origin } = isBrowser ? window.location : DEFAULT_LOCATION;

  return origin;
})();

export const hostname = () => {
  const { hostname } = isBrowser ? window.location : DEFAULT_LOCATION;
  return hostname;
};

/** 是否在APP环境 */
export const isApp = () => {
  return isBrowser && /bybit_app/.test(navigator.userAgent.toLowerCase());
};

export function isIOSApp() {
  return isBrowser && /bybit_app\/.*\/ios/.test(navigator.userAgent);
}

// 判断在web3小程序里
export const isInWeb3Mini = () => {
  return (
    isBrowser && isApp() && window.navigator.userAgent.indexOf('web3') > -1
  );
};

/** 是否在手机环境 */
export const isMobile = (() =>
  isBrowser &&
  /(ipod|ipad|iphone|android|mobile)/i.test(
    navigator.userAgent.toLowerCase()
  ))();

/** h5模式 */
export const isH5 = isApp() || isMobile;

/**
 * public下静态资源引入加上项目路径
 * */
export const publicAssetsPath = (filePath) => {
  return `${env === 'local' ? '' : appPath}${filePath}`;
};
